import { Component, computed, input, inject } from '@angular/core';
import { PaymentMethod } from '../../../../../_interfaces/subscription.interface';
import { environment } from '../../../../../../environments/environment';
import { Router } from '@angular/router';
import { EmptyIndicatorPipe } from '../../../../../shared/pipes/empty-indicator.pipe';

@Component({
  selector: 'app-payment-method',
  template: ` <div class="row mt-3">
    <div class="col-auto">
      <div class="text-muted mb-1">Payment method:</div>
      <i class="pays-svg-icon ic-card me-2 lead v-align"></i>
      @if (paymentMethod()) {
        <span class="fw-bold">{{ paymentMethod().card_number | emptyIndicator: '**** ****' }}</span> |
        <span class="fw-bold">{{ paymentMethod().card_expiry | emptyIndicator: 'N/A' }}</span>
      }
    </div>
    <div class="col-auto ms-auto">
      <a
        target="_blank"
        rel="noopener noreferrer"
        [href]="updatePaymentUrl()"
        class="btn-reset text-secondary btn-link">
        Change payment<span class="text-decoration-none"><i class="iconoir-arrow-up-right ms-1"></i></span>
      </a>
    </div>
  </div>`,
  imports: [EmptyIndicatorPipe],
})
export class PaymentMethodComponent {
  readonly router = inject(Router);

  paymentMethod = input.required<PaymentMethod>();
  payfastToken = input.required<string>();
  readonly dashUrl = environment.dashboardBaseUrl;
  protected returnUrl = computed<string>(() => {
    const isUpgrade = this.router.url.includes('upgrade');
    return encodeURIComponent(`${this.dashUrl}your-plan/${isUpgrade ? 'upgrade-plan' : 'manage'}`);
  });

  updatePaymentUrl = computed(() => {
    return 'https://www.payfast.co.za/eng/recurring/update/' + this.payfastToken() + '?return=' + this.returnUrl();
  });
}
